import { MARQUEE_ITEMS } from "../data/content";

export default function Marquee() {
  return (
    <div
      data-testid="marquee"
      className="overflow-hidden border-y border-line bg-surface/60 py-5"
    >
      <div className="animate-marquee flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {MARQUEE_ITEMS.map((item) => (
              <span
                key={item}
                className="flex items-center font-display text-2xl uppercase tracking-tight text-slate-100/90 lg:text-3xl"
              >
                <span className="px-7">{item}</span>
                <span className="inline-block h-2 w-2 rotate-45 bg-brand" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
